import './EmblaCarousel.scss';

import { EmblaOptionsType } from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
import useEmblaCarousel from 'embla-carousel-react';
import React from 'react';

import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from './EmblaCarouselArrowButtons';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';

type PropType = {
  options?: EmblaOptionsType;
  children: React.ReactNode;
  useAutoScroll?: boolean;
};

const EmblaCarousel: React.FC<PropType> = ({
  options,
  children,
  useAutoScroll = false,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    options,
    useAutoScroll
      ? [AutoScroll({ playOnInit: true, stopOnInteraction: false, speed: 1 })]
      : undefined,
  );

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {children &&
            React.Children.map(children, (child, index) => (
              <div className="embla__slide" key={index}>
                {child}
              </div>
            ))}
        </div>
      </div>

      <div className="embla__controls">
        <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={`embla__dot${
                index === selectedIndex ? ' embla__dot--selected' : ''
              }`}
            />
          ))}
        </div>
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>
    </section>
  );
};

export default EmblaCarousel;
